import { render, staticRenderFns } from "./ThemeRiver.vue?vue&type=template&id=7fdef3b5&"
import script from "./ThemeRiver.vue?vue&type=script&lang=js&"
export * from "./ThemeRiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports